import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import * as BSL_Common from "../../components/BSL_CommonControls";
import { DistanceXYZ } from "../../components/Common";
import BSL_Button from "../../components/BSL_Button";
import BSL_Dialog from "../../components/BSL_Dialog";
import * as APP from "../../redux_store/appState";
import { ClearScratch } from "../layout/PaperDesigner";
import {
    updateAreaSpecification,
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
} from "../../redux_store/jobState";
import { SHOW_DESIGNER_MESSAGE } from "../../redux_store/appState";

import BSL_Select from "../../components/BSL_Select";
import BSL_ColourSelector from "../../components/BSL_ColourSelector";
import { Slider } from "@material-ui/core";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import { GetHTMLColour, toNumber } from "../../components/Common";

const useStyles = makeStyles({
    root: {},
    slat: {
        height: "8px",
        width: "100%",
        background: "beige",
        border: "1px solid #80808052",
        boxShadow: "1px 1px 6px #8888885e */",
        marginTop: "2px",
    },
    slatwarning: {
        fontSize: "12px",
        color: "red",
    },
});

export const GetItems = (parameters) => {
    if (window.svg && window.paper) {
        return window.paper.project.getItems(parameters);
    }
    return null;
};

export default function SpecSlatsTool(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { edit_item, areaIndex } = props;
    const app = useSelector((state) => state.app);
    const AREA_INDEX = app.designer.designer2D?.[APP.AREA_INDEX];
    const job = useSelector((state) => state.job);
    const area_design_specs = job?.AreaSpecifications?.[areaIndex];
    const SELECTED_POINTS = app.designer.designer2D[APP.SELECTED_POINT];

    const config = useSelector((state) => state.config);
    const designType = area_design_specs.SHAPE.DesignType;
    const slat_options = config.slat_options;
    const area_config = config?.design_options?.[designType];

    const SELECT_POINT = app.designer.designer2D[APP.SELECT_POINT];
    const [showDialog, setShowDialog] = React.useState(edit_item ? true : false);
    const [waitingForPoints, setWaitingForPoints] = React.useState(false);
    const [lastSVGLoaded, setLastSVGLoaded] = React.useState(window.last_svg_load_attempt);
    const [firstItem, setFirstItem] = React.useState(false);
    const [movingPoints, setMovingPoints] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);
    const [alignment, setAlignment] = React.useState(edit_item?.Alignment ? edit_item.Alignment : 0);
    const [numSlats, setNumSlats] = React.useState(edit_item?.NumSlats ? edit_item.NumSlats : 15);

    let defaultSlat = area_design_specs.OPTIONS.SlatType;
    if (!area_config?.slat_options?.includes(defaultSlat)) {
        if (area_config?.slat_default) defaultSlat = area_config?.slat_default;
        else defaultSlat = area_config?.slat_options?.[0];
    }
    if (!defaultSlat) defaultSlat = "FS70";
    const [slatType, setSlatType] = React.useState(edit_item?.Type ? edit_item.Type : defaultSlat);

    const default_colour = slat_options?.[slatType]?.colours.includes(area_design_specs.OPTIONS.SlatColour)
        ? area_design_specs.OPTIONS.SlatColour
        : slat_options?.[slatType]?.colours.split(",")?.[0].trim();
    const [colour, setColour] = React.useState(edit_item?.Colour ? edit_item.Colour : default_colour);
    let defaultSpacing = Number(area_design_specs.OPTIONS.SlatRetainerSpacing);
    if (![10, 20, 30].includes(defaultSpacing)) defaultSpacing = 10;

    const [retainerSpacing, setRetainerSpacing] = React.useState(
        edit_item?.RetainerSpacing ? edit_item.RetainerSpacing : defaultSpacing
    );

    const [showMessage, setShowMessage] = React.useState(false);
    const [imageName, setImageName] = React.useState(edit_item?.Image ? edit_item.Image : "none");

    let edit_note_text = "";
    if (edit_item)
        for (let i = 1; i < 10; i++) {
            let text = edit_item["Note" + (i > 1 ? i : "")];
            if (text != undefined && text != null) edit_note_text += (edit_note_text === "" ? "" : "\n") + text;
        }

    const [inputValue, setInputValue] = React.useState(edit_note_text.replace("📷 ", ""));

    React.useEffect(() => {
        if (!loaded) return;
        if (edit_item) {
            if (waitingForPoints && SELECTED_POINTS) {
                let distance = DistanceXYZ(
                    SELECTED_POINTS[0].x,
                    SELECTED_POINTS[1].x,
                    SELECTED_POINTS[0].y,
                    SELECTED_POINTS[1].y
                );

                setWaitingForPoints(false);
                dispatch(APP.update2DDesigner(APP.SELECT_POINT, false));
                setInputValue("");
                setShowDialog(false);

                let p1 = "(" + SELECTED_POINTS[0].x.toFixed(2) + "," + SELECTED_POINTS[0].y.toFixed(2) + ",0.00)";
                let p2 = "(" + SELECTED_POINTS[1].x.toFixed(2) + "," + SELECTED_POINTS[1].y.toFixed(2) + ",0.00)";
                let ref = p1 + ";" + p2;

                let new_item = {
                    ...edit_item,
                    Ref: ref,
                    P1: p1,
                    P2: p2,
                };
                new_item.NumSlats = numSlats;
                new_item.Alignment = alignment;
                new_item.Type = slatType;
                new_item.Colour = colour;
                new_item.RetainerSpacing = retainerSpacing;

                dispatch(
                    updateAreaSpecificationModificationArray(
                        AREA_INDEX > -1 ? AREA_INDEX : areaIndex,
                        "SlatPanels",
                        edit_item.Ref,
                        null,
                        new_item,
                        true
                    )
                );
                onClose();
            }
            return;
        } else if (waitingForPoints && SELECTED_POINTS) {
            let distance = DistanceXYZ(
                SELECTED_POINTS[0].x,
                SELECTED_POINTS[1].x,
                SELECTED_POINTS[0].y,
                SELECTED_POINTS[1].y
            );

            setWaitingForPoints(false);
            dispatch(APP.update2DDesigner(APP.SELECT_POINT, 0));
            setInputValue("");
            setShowDialog(true);
        }
    }, [SELECTED_POINTS]);

    if (loaded && waitingForPoints && window.last_svg_load_attempt != lastSVGLoaded) {
        setLastSVGLoaded(window.last_svg_load_attempt);
        reFormatSVG(0);
    }

    function reFormatSVG(count) {
        if (count > 20) {
            FormatSVGForSlats(props.pop_item);
            return;
        }
        setTimeout(function () {
            if (firstItem == window.paper.project.activeLayer.children[0]) {
                reFormatSVG(count + 1);
            } else {
                FormatSVGForSlats(props.pop_item);
            }
        }, 100);
    }

    const SetChildrenGrey = (item) => {
        if (!item?.children) return;
        item.children.forEach(function (item) {
            if (window.last_pop_item === item) {
                return;
            }
            item.fillColor_original = item.fillColor;
            item.strokeColor_original = item.strokeColor;
            if (item.is_roofsheet || item.is_attachment || item.is_gutter) {
                if (item.fillColor) item.fillColor = "#dddddd";
                if (item.strokeColor) item.strokeColor = "#bbbbbb";
            }
            item.pickable = false;
            if (item.children) {
                SetChildrenGrey(item);
            }
        });
    };

    function FormatSVGForSlats(areaIndex) {
        let items = GetItems();
        setFirstItem(items?.[0]);
        if (items?.[0]?.children) {
            SetChildrenGrey(items?.[0]);
        }

        GetItems({ class: window.paper.TextItem }).forEach(function (item) {
            item.sendToBack();
        });

        GetItems({ is_post: true }).forEach(function (item) {
            item.bringToFront();
            item.fillColor = item.fillColor_original;
            item.strokeColor = item.strokeColor_original;
        });
        GetItems({ is_slat_post: true }).forEach(function (item) {
            item.bringToFront();
            window.paper.project.activeLayer.addChild(item);
            item.fillColor = item.fillColor_original;
            item.strokeColor = item.strokeColor_original;
        });
        GetItems({ is_slat: true }).forEach(function (slat) {
            slat.bringToFront();
            slat.strokeWidth = 24;
            slat.strokeColor = "#abb126ff";
            slat.fillColor = "##f0fa37ff";
        });
    }

    React.useEffect(() => {
        if (AREA_INDEX !== areaIndex && job.AreaSpecifications.length > 1) return;
        else if (AREA_INDEX !== areaIndex) return;
        if (!loaded) return;
        if (SELECT_POINT === false) {
            setWaitingForPoints(false);
            setShowDialog(false);
            dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, false));
            if (job.AreaSpecifications.length > 1) {
                dispatch(APP.setDesignerLoadingBackdrop("Loading Full Layout..."));
                dispatch(APP.update2DDesigner(APP.AREA_INDEX, -1));
            }
        }
    }, [SELECT_POINT]);

    const getMoveSlatPoints = () => {
        setMovingPoints(false);
        setWaitingForPoints(true);
        ClearScratch();
        if (job.AreaSpecifications.length > 1) {
            dispatch(APP.update2DDesigner(APP.AREA_INDEX, areaIndex));
            dispatch(APP.setDesignerLoadingBackdrop("Loading Area " + (areaIndex + 1) + " Layout..."));
        }
        dispatch(
            APP.update2DDesigner(
                APP.SELECT_POINT_NOTE,
                <>
                    First, click a point to set where your would like to start the slats. If close to a post or wall line, it will
                    snap to the post or wall line.
                    <br />
                    Next, click where you would like to end the slats.
                    <br />
                    *Right click or press 'ESC' to cancel.
                </>
            )
        );
        dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, true));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, 2));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT_ALLOW_HIT_SELTYPE, ["slat_panel", "slat_label"]));
    };

    const wipeNotes = () => {
        dispatch(updateAreaSpecification(AREA_INDEX > -1 ? AREA_INDEX : areaIndex, "SlatPanels", null, []));
    };

    const onClose = () => {
        ClearScratch();
        setInputValue("");
        setShowDialog(false);

        if (props.onClose) {
            props.onClose();
            return;
        }

        setWaitingForPoints(true);
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, 2));
    };

    if (!loaded) setLoaded(true);

    let slat_width = toNumber(slatType) + Number(retainerSpacing);
    let total_height = numSlats * slat_width;

    let slats = [];
    let slat_html = GetHTMLColour(area_design_specs.OPTIONS.SlatColour);
    if (alignment === 0) {
        slats.push(
            <div>
                {numSlats} SLATS ({total_height}mm)
            </div>
        );
        if (total_height > 1800)
            slats.push(
                <div className={classes.slatwarning}>
                    if height {">"} 1800mm, reinforcement posts and
                    <br />
                    supplemantary engineering required
                </div>
            );
        else if (total_height > 1250)
            slats.push(
                <div className={classes.slatwarning}>
                    if height {">"} 1250mm, supplemantary engineering
                    <br />
                    required
                </div>
            );
        if (total_height > area_design_specs.SHAPE.Height)
            slats.push(
                <div className={classes.slatwarning}>
                    warning: height {">"} nominated area height ({area_design_specs.SHAPE.Height}mm)
                </div>
            );
    }
    for (let i = 0; i < numSlats; i++) {
        slats.push(<div className={classes.slat} style={{ background: slat_html }}></div>);
    }
    if (alignment !== 0) {
        slats.push(
            <div>
                {numSlats} SLATS ({total_height}mm)
            </div>
        );
        if (total_height > 1250)
            slats.push(
                <div className={classes.slatwarning}>
                    if height {">"} 1250mm, supplemantary engineering
                    <br />
                    required
                </div>
            );
        if (total_height > area_design_specs.SHAPE.Height)
            slats.push(
                <div className={classes.slatwarning}>
                    warning: height {">"} nominated area height ({area_design_specs.SHAPE.Height}mm)
                </div>
            );
    }

    let max = 36;
    if (numSlats > max - 2) {
        max = numSlats + 2;
        if (max > 48) max = 48;
    }

    return (
        <>

            {!edit_item && (
                <BSL_Common.SectionContainer>
                    <BSL_Common.SectionRow>
                        <BSL_Button
                            style={{ marginLeft: "8px", alignSelf: "center", width: "60%" }}
                            onClick={getMoveSlatPoints}
                            disabled={app.designer.threeDMode && !app.designer.threeDMiniMode}
                            disabledTooltip={"Slats cannot be added in 3D mode"}
                        >
                            Add Slats{" "}
                            {app.designer.threeDMode && !app.designer.threeDMiniMode ? "(Plan View only)" : ""}
                        </BSL_Button>
                        <BSL_Button
                            secondary
                            style={{ marginLeft: "8px", alignSelf: "center", flex: 1 }}
                            onClick={wipeNotes}
                        >
                            Wipe All (Area)
                        </BSL_Button>
                    </BSL_Common.SectionRow>
                </BSL_Common.SectionContainer>
            )}
            {/* {showMessage &&
                <Message open={showMessage} message={showMessage?.message} type={showMessage?.type} onClose={() => setShowMessage(null)} />
            } */}
            {showDialog && (
                <BSL_Dialog
                    title="Add Slats"
                    open={showDialog}
                    onClose={onClose}
                    button1Text={"Save"}
                    button1Click={() => {
                        onClose();
                        let new_item;
                        if (edit_item) {
                            new_item = { ...edit_item };
                        } else {
                            let p1 = { ...SELECTED_POINTS[0] };
                            let p2 = { ...SELECTED_POINTS[1] };

                            if (job.AreaSpecifications[areaIndex > -1 ? areaIndex : 0].SHAPE.RotateArea === 1) {
                                p1.y = SELECTED_POINTS[0].x;
                                p1.x = -SELECTED_POINTS[0].y;
                                p2.y = SELECTED_POINTS[1].x;
                                p2.x = -SELECTED_POINTS[1].y;
                            }

                            if (p1.x > p2.x) {
                                let p_hold = p2;
                                p2 = p1;
                                p1 = p_hold;
                            }

                            let p1_str = "(" + p1.x.toFixed(2) + "," + p1.y.toFixed(2) + ",0.00)";
                            let p2_str = "(" + p2.x.toFixed(2) + "," + p2.y.toFixed(2) + ",0.00)";

                            let ref = p1_str + ";" + p2_str;
                            new_item = {
                                Ref: ref,
                                P1: p1_str,
                                P2: p2_str,
                                NumSlats: numSlats,
                                Alignment: alignment,
                                Type: slatType,
                                Colour: colour,
                                RetainerSpacing: retainerSpacing,
                            };
                        }
                        new_item.NumSlats = numSlats;
                        new_item.Alignment = alignment;
                        new_item.Type = slatType;
                        new_item.Colour = colour;
                        new_item.RetainerSpacing = retainerSpacing;

                        dispatch(
                            updateAreaSpecificationModificationArray(
                                AREA_INDEX > -1 ? AREA_INDEX : areaIndex,
                                "SlatPanels",
                                new_item.Ref,
                                null,
                                new_item,
                                true
                            )
                        );
                        setInputValue("");
                    }}
                    button2Text="Cancel"
                    button2Click={onClose}
                    button3Text={edit_item ? "Delete Slats" : null}
                    button3Click={() => {
                        onClose();
                        dispatch(
                            deleteFromAreaSpecificationModificationArray(
                                AREA_INDEX > -1 ? AREA_INDEX : areaIndex,
                                "SlatPanels",
                                edit_item.Ref
                            )
                        );
                    }}
                >
                    <SegmentedButtonGroup
                        label="Alignment"
                        tight
                        value={alignment}
                        items={[
                            {
                                Key: 0,
                                Display: "Bottom",
                            },
                            {
                                Key: 1,
                                Display: "Top",
                            },
                        ]}
                        onChange={(e, v) => setAlignment(v)}
                        style={{
                            marginTop: "-12px",
                            flex: 7,
                            textAlignLast: "center",
                            textAlign: "-webkit-center",
                        }}
                    />
                    <BSL_Common.SectionRow>
                        <Slider
                            orientation="vertical"
                            value={alignment === 0 ? numSlats : max - numSlats}
                            marks
                            min={1}
                            max={max}
                            onChange={(e, v) => {
                                setNumSlats(alignment === 0 ? Number(v) : max - Number(v) + 1);
                            }}
                            aria-labelledby="vertical-slider"
                            style={{
                                minHeight: 10 * max + "px",
                            }}
                            track={alignment === 0 ? "" : "inverted"}
                        />
                        <div
                            style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: alignment === 0 ? "flex-end" : "flex-start",
                            }}
                        >
                            {slats}
                        </div>
                    </BSL_Common.SectionRow>
                    <BSL_Common.SectionRow>
                        <BSL_Select
                            label="Slat Types"
                            style={{ flex: 1 }}
                            value={slatType}
                            tight={true}
                            items={area_config.slat_options}
                            onChange={(e) => {
                                setSlatType(e.target.value);
                            }}
                        />
                        <BSL_Select
                            label="Spacing"
                            style={{ flex: 1 }}
                            value={retainerSpacing}
                            tight={true}
                            items={[
                                { Key: 10, Display: "10 mm" },
                                { Key: 20, Display: "20 mm" },
                                { Key: 30, Display: "30 mm" },
                            ]}
                            onChange={(e) => {
                                setRetainerSpacing(e.target.value);
                            }}
                        />
                        <BSL_ColourSelector
                            tight
                            label="Colour"
                            colourList={slat_options?.[slatType]?.colours}
                            value={colour}
                            onChange={(value) => {
                                setColour(value);
                            }}
                            style={{
                                flex: 2,
                            }}
                        />
                    </BSL_Common.SectionRow>
                </BSL_Dialog>
            )}
        </>
    );
}
